module.exports = __webpack_public_path__ + "static/media/btg_03.433cdc13.png";